import Vue from 'vue'

export default {

    /**
     * Set page title
     * @param state
     * @param title
     * @constructor
     */
    SET_VAR(state, {name, val})
    {
        // Store val
        Vue.set(state.vars, name, val);
    },


}
